import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
    selector: '[tflRuleHover]'
})
export class RuleHoverDirective {


    @Input('tflRuleHover')
    public index: number;
    @Output('ruleHover')
    public hover = new EventEmitter();

    @HostListener('mouseenter', ['$event'])
    onMouseEnter($event) {
        this.hover.next({
            index: this.index,
            hovering: true
        });
    }

    @HostListener('mouseleave', ['$event'])
    onMouseLeave($event) {
        this.hover.next({
            index: this.index,
            hovering: false
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/rules/rule-hover.directive.ts